module.exports = __webpack_public_path__ + "static/media/variety-1.5f2af565.jpg";